import { Routes, Route } from "react-router-dom";
import PrivateAuth from '../../authorization/PrivateAuth';
import CreatePurchaseReturnBulk from "../../../pages/Inbound-return/Bulk/Purchase-Return-Bulk-Create/CreatePurchaseReturnBulk";
import Createpick from "../../../pages/Inbound-return/Bulk/Create-Pick/Create-pick";


function InboundReturnRoute() {

    return (
        <Routes>
            <Route element={<PrivateAuth />}>
                <Route path="/purchaseorder/create-purchase-return-bulk" element={<CreatePurchaseReturnBulk />} />
                <Route path="/purchaseorder/create-pick-list-return-bulk" element={<Createpick />} />
            </Route>
        </Routes>
    );
}

export default InboundReturnRoute;
